/**
 * Header / cards / PDP pincode + ClickPost EDD.
 */
(function () {
  const KPE_PIN_KEY = 'kiehls_delivery_pincode';
  const KPE_CITY_KEY = 'kiehls_delivery_city';
  const KPE_EDD_KEY = 'kiehls_delivery_edd';
  const KPE_SOURCE_KEY = 'kiehls_pin_source';
  const KPE_PIN_RE = /^[1-9][0-9]{5}$/;
  const KPE_FETCH_MS = 8000;
  const KPE_GEO_MS = 4000;
  const KPE_TRUCK_SVG =
    '<svg class="edd-truck" xmlns="http://www.w3.org/2000/svg" width="23" height="16" viewBox="0 0 23 16" fill="none" aria-hidden="true"><path d="M6.22221 12.1588H4.44444C4.32657 12.1588 4.21352 12.1119 4.13017 12.0286C4.04683 11.9452 4 11.8322 4 11.7143C4 11.5965 4.04683 11.4834 4.13017 11.4001C4.21352 11.3167 4.32657 11.2699 4.44444 11.2699H6.22221C6.34008 11.2699 6.45313 11.3167 6.53648 11.4001C6.61983 11.4834 6.66665 11.5965 6.66665 11.7143C6.66665 11.8322 6.61983 11.9452 6.53648 12.0286C6.45313 12.1119 6.34008 12.1588 6.22221 12.1588ZM20.6666 12.1588H19.5555C19.4376 12.1588 19.3245 12.1119 19.2412 12.0286C19.1578 11.9452 19.111 11.8322 19.111 11.7143C19.111 11.5965 19.1578 11.4834 19.2412 11.4001C19.3245 11.3167 19.4376 11.2699 19.5555 11.2699H20.2977L20.8968 8.07701C20.8888 6.44324 19.4932 5.0477 17.7777 5.0477H14.8595L13.4453 11.2699H15.9999C16.1178 11.2699 16.2309 11.3167 16.3142 11.4001C16.3975 11.4834 16.4444 11.5965 16.4444 11.7143C16.4444 11.8322 16.3975 11.9452 16.3142 12.0286C16.2309 12.1119 16.1178 12.1588 15.9999 12.1588H12.8888C12.8221 12.1588 12.7563 12.1438 12.6962 12.115C12.6361 12.0861 12.5832 12.044 12.5416 11.992C12.4999 11.9399 12.4705 11.8791 12.4555 11.8141C12.4405 11.7491 12.4404 11.6816 12.4551 11.6165L14.0711 4.50548C14.0933 4.40703 14.1483 4.31907 14.2271 4.25607C14.306 4.19306 14.4039 4.15876 14.5048 4.15881H17.7777C19.983 4.15881 21.7777 5.95347 21.7777 8.15879L21.103 11.7961C21.0839 11.8979 21.0299 11.9899 20.9502 12.0562C20.8705 12.1224 20.7702 12.1587 20.6666 12.1588Z" fill="currentColor"/><path d="M17.7785 13.9365C16.5537 13.9365 15.5563 12.9401 15.5563 11.7143C15.5563 10.4885 16.5537 9.49208 17.7785 9.49208C19.0034 9.49208 20.0008 10.4885 20.0008 11.7143C20.0008 12.9401 19.0034 13.9365 17.7785 13.9365ZM17.7785 10.381C17.0434 10.381 16.4452 10.9792 16.4452 11.7143C16.4452 12.4494 17.0434 13.0476 17.7785 13.0476C18.5137 13.0476 19.1119 12.4494 19.1119 11.7143C19.1119 10.9792 18.5137 10.381 17.7785 10.381ZM8.00082 13.9365C6.77594 13.9365 5.77861 12.9401 5.77861 11.7143C5.77861 10.4885 6.77594 9.49208 8.00082 9.49208C9.22571 9.49208 10.223 10.4885 10.223 11.7143C10.223 12.9401 9.22571 13.9365 8.00082 13.9365ZM8.00082 10.381C7.26572 10.381 6.6675 10.9792 6.6675 11.7143C6.6675 12.4494 7.26572 13.0476 8.00082 13.0476C8.73593 13.0476 9.33415 12.4494 9.33415 11.7143C9.33415 10.9792 8.73593 10.381 8.00082 10.381ZM6.22306 4.15878H2.66752C2.54965 4.15878 2.4366 4.11196 2.35325 4.02861C2.2699 3.94526 2.22308 3.83221 2.22308 3.71434C2.22308 3.59647 2.2699 3.48342 2.35325 3.40007C2.4366 3.31672 2.54965 3.2699 2.66752 3.2699H6.22306C6.34093 3.2699 6.45398 3.31672 6.53732 3.40007C6.62067 3.48342 6.6675 3.59647 6.6675 3.71434C6.6675 3.83221 6.62067 3.94526 6.53732 4.02861C6.45398 4.11196 6.34093 4.15878 6.22306 4.15878ZM6.22306 6.82543H1.77864C1.66076 6.82543 1.54772 6.77861 1.46437 6.69526C1.38102 6.61191 1.3342 6.49886 1.3342 6.38099C1.3342 6.26312 1.38102 6.15007 1.46437 6.06672C1.54772 5.98337 1.66076 5.93655 1.77864 5.93655H6.22306C6.34093 5.93655 6.45398 5.98337 6.53732 6.06672C6.62067 6.15007 6.6675 6.26312 6.6675 6.38099C6.6675 6.49886 6.62067 6.61191 6.53732 6.69526C6.45398 6.77861 6.34093 6.82543 6.22306 6.82543ZM6.22306 9.49208H0.889754C0.771881 9.49208 0.658836 9.44526 0.575486 9.36191C0.492137 9.27856 0.445313 9.16552 0.445312 9.04764C0.445312 8.92977 0.492137 8.81672 0.575486 8.73337C0.658836 8.65002 0.771881 8.6032 0.889754 8.6032H6.22306C6.34093 8.6032 6.45398 8.65002 6.53732 8.73337C6.62067 8.81672 6.6675 8.92977 6.6675 9.04764C6.6675 9.16552 6.62067 9.27856 6.53732 9.36191C6.45398 9.44526 6.34093 9.49208 6.22306 9.49208Z" fill="currentColor"/><path d="M12.8888 12.1587H9.77774C9.65987 12.1587 9.54682 12.1118 9.46348 12.0285C9.38013 11.9451 9.3333 11.8321 9.3333 11.7142C9.3333 11.5964 9.38013 11.4833 9.46348 11.4C9.54682 11.3166 9.65987 11.2698 9.77774 11.2698H12.5342L14.5537 2.38095H4.44444C4.32657 2.38095 4.21352 2.33412 4.13017 2.25078C4.04683 2.16743 4 2.05438 4 1.93651C4 1.81863 4.04683 1.70559 4.13017 1.62224C4.21352 1.53889 4.32657 1.49207 4.44444 1.49207H15.111C15.1777 1.49203 15.2436 1.50701 15.3037 1.53588C15.3638 1.56476 15.4167 1.60679 15.4583 1.65887C15.5 1.71094 15.5294 1.77173 15.5444 1.83672C15.5593 1.9017 15.5595 1.96923 15.5448 2.03428L13.3226 11.812C13.3004 11.9105 13.2454 11.9984 13.1665 12.0614C13.0877 12.1244 12.9898 12.1587 12.8888 12.1587Z" fill="currentColor"/></svg>';

  const kpeCfg = window.KiehlsPincodeEdd || {};
  const kpeMem = { savedPin: '', savedCity: '', savedEdd: null, pinSource: '' };
  let kpeApplySeq = 0;
  let kpeSlaPin = '';
  let kpeSlaPromise = null;
  let kpeCardKey = '';
  let kpePainting = false;
  let kpeHeaderBound = false;
  let kpeModalBound = false;
  let kpePdpBound = false;
  let kpeGeoBusy = false;
  let kpeGeoGestureBound = false;

  function isValidPin(value) {
    return KPE_PIN_RE.test(String(value || '').trim());
  }

  function parseJsonSafe(text) {
    const raw = String(text || '').trim();
    if (!raw) throw new Error('empty json');
    try {
      return JSON.parse(raw);
    } catch (e) {
      const brace = raw.indexOf('{');
      const bracket = raw.indexOf('[');
      let start = -1;
      if (brace === -1) start = bracket;
      else if (bracket === -1) start = brace;
      else start = Math.min(brace, bracket);
      if (start < 0) throw e;
      return JSON.parse(raw.slice(start));
    }
  }

  function isSameOriginUrl(url) {
    try {
      if (!url) return true;
      if (url.charAt(0) === '/' && url.charAt(1) !== '/') return true;
      return new URL(url, location.href).origin === location.origin;
    } catch (e) {
      return true;
    }
  }

  function fetchJson(url, timeoutMs, options) {
    const kpeWaitMs = timeoutMs || KPE_FETCH_MS;
    const kpeHttpMethod = String((options && options.method) || 'GET').toUpperCase();
    const kpeHeaders = Object.assign({ Accept: 'application/json' }, (options && options.headers) || {});
    const kpeBody = options && options.body ? options.body : null;
    const kpeSameOrigin = isSameOriginUrl(url);

    return new Promise((resolve, reject) => {
      let settled = false;
      const finish = (fn, value) => {
        if (settled) return;
        settled = true;
        fn(value);
      };

      if (kpeSameOrigin) {
        try {
          const xhr = new XMLHttpRequest();
          xhr.open(kpeHttpMethod, url, true);
          xhr.timeout = kpeWaitMs;
          xhr.withCredentials = true;
          Object.keys(kpeHeaders).forEach((name) => {
            try {
              xhr.setRequestHeader(name, kpeHeaders[name]);
            } catch (e) {
              /* ignore forbidden header */
            }
          });
          xhr.onload = () => {
            if (xhr.status < 200 || xhr.status >= 400) {
              finish(reject, new Error('bad status ' + xhr.status));
              return;
            }
            try {
              finish(resolve, parseJsonSafe(xhr.responseText || '{}'));
            } catch (err) {
              finish(reject, err);
            }
          };
          xhr.onerror = () => finish(reject, new Error('network'));
          xhr.ontimeout = () => finish(reject, new Error('timeout'));
          xhr.send(kpeBody);
          return;
        } catch (err) {
          /* fall through to fetch */
        }
      }

      const timer = setTimeout(() => finish(reject, new Error('timeout')), kpeWaitMs);
      fetch(
        url,
        Object.assign(
          {
            credentials: kpeSameOrigin ? 'include' : 'omit',
            mode: kpeSameOrigin ? 'same-origin' : 'cors',
          },
          options || {},
          { headers: kpeHeaders }
        )
      )
        .then((res) => {
          if (!res.ok) throw new Error('bad status');
          return res.text();
        })
        .then((text) => finish(resolve, parseJsonSafe(text || '{}')))
        .catch((err) => finish(reject, err))
        .then(() => clearTimeout(timer));
    });
  }

  function ordinalDay(date) {
    const n = date.getDate();
    const j = n % 10;
    const k = n % 100;
    let suffix = 'th';
    if (j === 1 && k !== 11) suffix = 'st';
    else if (j === 2 && k !== 12) suffix = 'nd';
    else if (j === 3 && k !== 13) suffix = 'rd';
    return n + suffix;
  }

  function addDaysTo(date, days) {
    const next = new Date(date.getTime());
    next.setDate(next.getDate() + Number(days || 0));
    return next;
  }

  function parseYmd(value) {
    const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    const date = match
      ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
      : new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }

  function eddRangeCopy(startDate, endDate) {
    const start = new Date(startDate.getTime());
    let end = new Date(endDate.getTime());
    if (end.getTime() <= start.getTime()) end = addDaysTo(start, 1);
    const endMonth = end.toLocaleDateString('en-GB', { month: 'short' });
    const startPart =
      start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()
        ? ordinalDay(start)
        : ordinalDay(start) + ' ' + start.toLocaleDateString('en-GB', { month: 'short' });
    return {
      label: 'Delivery between',
      date: startPart + ' to ' + ordinalDay(end) + ' ' + endMonth,
      card: end.getDate() + ' ' + endMonth,
    };
  }

  function pdpEddHtml(startDate, endDate) {
    const copy = eddRangeCopy(startDate, endDate);
    return (
      KPE_TRUCK_SVG +
      ' <span class="delivery-by-label">Get it by</span><span class="delivery-date">' +
      copy.card +
      '</span>'
    );
  }

  function unserviceableEdd(pincode) {
    return {
      unserviceable: true,
      source: 'clickpost-app',
      pincode: pincode,
      message: 'Delivery Not Available for this Pincode',
      headerText: '',
      pdpHtml: '',
      cardText: '',
      fetchedAt: Date.now(),
    };
  }

  function failedEdd(pincode) {
    return {
      unserviceable: true,
      source: 'clickpost-app',
      pincode: pincode,
      message: 'Unable to check delivery. Please try again.',
      headerText: '',
      pdpHtml: '',
      cardText: '',
      fetchedAt: Date.now(),
    };
  }

  function isFailedCheck(edd) {
    return Boolean(edd && String(edd.message || '').indexOf('Unable to check') !== -1);
  }

  function usableEdd(edd, pincode) {
    return Boolean(edd && edd.pincode === pincode && !isFailedCheck(edd) && (edd.cardText || edd.unserviceable));
  }

  function isFreshEdd(edd, pincode) {
    if (!usableEdd(edd, pincode) || !edd.cardText || !edd.fetchedAt) return false;
    const a = new Date(edd.fetchedAt);
    const b = new Date();
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  function sameEdd(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return (
      a.pincode === b.pincode &&
      a.cardText === b.cardText &&
      a.unserviceable === b.unserviceable &&
      a.message === b.message
    );
  }

  function readPinCookie() {
    try {
      const parts = ('; ' + document.cookie).split('; ' + KPE_PIN_KEY + '=');
      if (parts.length < 2) return '';
      return decodeURIComponent(parts.pop().split(';').shift() || '').trim();
    } catch (e) {
      return '';
    }
  }

  function writePinCookie(pin) {
    try {
      const secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = pin
        ? KPE_PIN_KEY + '=' + encodeURIComponent(pin) + '; path=/; max-age=31536000; SameSite=Lax' + secure
        : KPE_PIN_KEY + '=; path=/; max-age=0; SameSite=Lax' + secure;
    } catch (e) {
      /* ignore */
    }
  }

  function loadMem() {
    try {
      kpeMem.savedPin = (
        localStorage.getItem(KPE_PIN_KEY) ||
        localStorage.getItem('selectedPincode') ||
        readPinCookie() ||
        ''
      ).trim();
      kpeMem.savedCity = (localStorage.getItem(KPE_CITY_KEY) || '').trim();
      kpeMem.pinSource = (localStorage.getItem(KPE_SOURCE_KEY) || '').trim();
    } catch (e) {
      kpeMem.savedPin = kpeMem.savedPin || readPinCookie();
    }
    try {
      const raw = localStorage.getItem(KPE_EDD_KEY);
      kpeMem.savedEdd = raw ? JSON.parse(raw) : null;
      if (kpeMem.savedEdd && kpeMem.savedEdd.pincode === kpeMem.savedPin && !kpeMem.savedEdd.unserviceable && kpeMem.savedEdd.min && kpeMem.savedEdd.max) {
        const startDate = new Date(kpeMem.savedEdd.min);
        const byDate = new Date(kpeMem.savedEdd.max);
        if (!Number.isNaN(startDate.getTime()) && !Number.isNaN(byDate.getTime())) {
          const copy = eddRangeCopy(startDate, byDate);
          kpeMem.savedEdd.range = copy.date;
          kpeMem.savedEdd.headerText = copy.label + ' ' + copy.date;
          kpeMem.savedEdd.pdpHtml = pdpEddHtml(startDate, byDate);
          kpeMem.savedEdd.cardText = copy.card || copy.date;
        }
      }
    } catch (e) {
      kpeMem.savedEdd = null;
    }
    if (kpeMem.savedPin && readPinCookie() !== kpeMem.savedPin) writePinCookie(kpeMem.savedPin);
  }

  function slaMinMax(row) {
    if (!row || typeof row !== 'object') return null;
    const min = row.predicted_sla_min != null ? row.predicted_sla_min : row.predictedSlaMin != null ? row.predictedSlaMin : row.sla_min != null ? row.sla_min : row.min_sla;
    const max = row.predicted_sla_max != null ? row.predicted_sla_max : row.predictedSlaMax != null ? row.predictedSlaMax : row.sla_max != null ? row.sla_max : row.max_sla;
    if (min == null && max == null) return null;
    return Object.assign({}, row, {
      predicted_sla_min: min != null ? min : max,
      predicted_sla_max: max != null ? max : min,
    });
  }

  function extractSla(data) {
    const visit = (node, depth) => {
      if (!node || depth > 5) return null;
      if (Array.isArray(node)) {
        for (let i = 0; i < node.length; i++) {
          const found = visit(node[i], depth + 1);
          if (found) return found;
        }
        return null;
      }
      const sla = slaMinMax(node);
      if (sla) return sla;
      if (typeof node !== 'object') return null;
      const keys = ['result', 'data', 'edd', 'response', 'payload'];
      for (let k = 0; k < keys.length; k++) {
        if (node[keys[k]]) {
          const found = visit(node[keys[k]], depth + 1);
          if (found) return found;
        }
      }
      return null;
    };
    return visit(data, 0);
  }

  function availablePinsFrom(avail) {
    if (!avail || typeof avail !== 'object') return [];
    const raw =
      avail.availablePincodes ||
      avail.available_pincodes ||
      (avail.result && (avail.result.availablePincodes || avail.result.available_pincodes)) ||
      (avail.data && (avail.data.availablePincodes || avail.data.available_pincodes)) ||
      [];
    return Array.isArray(raw) ? raw.filter(Boolean) : [];
  }

  function buildEddFromSla(sla, pincode, creds) {
    const extra = Number((creds && creds.standardEdd) || 0);
    const pickup = parseYmd(sla && sla.pickup_date);
    const minDays = Number((sla && sla.predicted_sla_min) || 0) + extra;
    const maxDays = Number((sla && sla.predicted_sla_max) || (sla && sla.predicted_sla_min) || 0) + extra;
    const startDate = addDaysTo(pickup, minDays);
    const byDate = addDaysTo(pickup, maxDays);
    const copy = eddRangeCopy(startDate, byDate);
    return {
      unserviceable: false,
      source: 'clickpost-app',
      pincode: pincode,
      min: startDate.toISOString(),
      max: byDate.toISOString(),
      range: copy.date,
      headerText: copy.label + ' ' + copy.date,
      pdpHtml: pdpEddHtml(startDate, byDate),
      cardText: copy.card || copy.date,
      fetchedAt: Date.now(),
    };
  }

  function clickpostCreds() {
    const live = window.KiehlsPincodeEdd || {};
    return {
      username: live.username || (kpeCfg && kpeCfg.username) || 'nykaa-kiehls',
      key: live.key || (kpeCfg && kpeCfg.key) || '3f2d68ae-48d9-48b1-865f-5c89154eabae',
      pickup: String(live.pickup || (kpeCfg && kpeCfg.pickup) || '421302').replace(/\D/g, '').slice(0, 6),
      standardEdd: Number(live.standardEdd != null ? live.standardEdd : (kpeCfg && kpeCfg.standardEdd) || 1) || 0,
    };
  }

  function postClickpost(path, body) {
    const payload = JSON.stringify(body);
    const opts = {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: payload,
    };
    return fetchJson(path, KPE_FETCH_MS, opts).catch(() => {
      if (path.slice(-1) !== '/') return fetchJson(path + '/', KPE_FETCH_MS, opts);
      throw new Error('proxy fail');
    });
  }

  function requestEdd(pincode, pins, avail, creds) {
    return postClickpost('/apps/clickpost-edd-proxy/edd', [
      {
        dropPincode: pincode,
        pickupPincodes: pins,
        method: 'single',
        pincodeCutoffMap: (avail && (avail.pincodeCutoffMap || avail.pincode_cutoff_map)) || {},
        ext: true,
      },
    ]).then((data) => {
      const sla = extractSla(data);
      return sla ? buildEddFromSla(sla, pincode, creds) : failedEdd(pincode);
    });
  }

  function lookupClickpostApi(pincode) {
    const creds = clickpostCreds();
    if (!isValidPin(creds.pickup) || !creds.username || !creds.key) {
      return Promise.resolve(failedEdd(pincode));
    }
    return requestEdd(pincode, [creds.pickup], {}, creds).catch(() =>
      postClickpost('/apps/clickpost-edd-proxy/availability', [
        { dropPincode: pincode, pickupPincode: creds.pickup, method: 'single', ext: true },
      ]).then((avail) => {
        const pins = availablePinsFrom(avail);
        if (avail && (avail.unserviceable || avail.serviceable === false) && !pins.length) {
          return unserviceableEdd(pincode);
        }
        return requestEdd(pincode, pins.length ? pins : [creds.pickup], avail, creds);
      })
    ).catch(() => failedEdd(pincode));
  }

  function lookupEdd(pincode) {
    if (kpeSlaPromise && kpeSlaPin === pincode) return kpeSlaPromise;
    kpeSlaPin = pincode;
    kpeSlaPromise = lookupClickpostApi(pincode).then(
      (edd) => {
        if (kpeSlaPin === pincode) {
          kpeSlaPromise = null;
          kpeSlaPin = '';
        }
        return edd;
      },
      (err) => {
        if (kpeSlaPin === pincode) {
          kpeSlaPromise = null;
          kpeSlaPin = '';
        }
        return failedEdd(pincode);
      }
    );
    return kpeSlaPromise;
  }

  function getModal() {
    return document.querySelector('[data-pincode-modal]');
  }

  function storedPincode() {
    try {
      const pin = localStorage.getItem(KPE_PIN_KEY) || localStorage.getItem('selectedPincode') || readPinCookie() || kpeMem.savedPin || '';
      return isValidPin(pin) ? String(pin).trim() : '';
    } catch (e) {
      return isValidPin(kpeMem.savedPin) ? kpeMem.savedPin : '';
    }
  }

  function paintHeaderPin(pincode) {
    let pin = isValidPin(pincode) ? String(pincode).trim() : '';
    if (!pin) {
      const saved = storedPincode() || kpeMem.savedPin;
      if (isValidPin(saved)) pin = String(saved).trim();
    }
    kpePainting = true;
    const roots = document.querySelectorAll('[data-header-pincode]');
    for (let i = 0; i < roots.length; i++) {
      const root = roots[i];
      const labelEl = root.querySelector('[data-pincode-label]');
      const pinEl = root.querySelector('[data-pincode-value]');
      const isMobile = root.classList.contains('header-pincode--mobile');
      const nextLabel = pin || (isMobile ? 'Enter Pincode' : 'Enter pincode');
      if (labelEl && labelEl.textContent !== nextLabel) labelEl.textContent = nextLabel;
      if (pinEl && pinEl.textContent !== pin) pinEl.textContent = pin;
      root.classList.toggle('is-set', Boolean(pin));
    }

    const modal = getModal();
    const input = modal && modal.querySelector('[data-pincode-input]');
    if (input && document.activeElement !== input && input.value !== pin) input.value = pin;
    kpePainting = false;
  }

  function updateProductCards(edd, pincode) {
    const nodes = document.querySelectorAll('[data-kpc-edd]');
    const count = nodes.length;
    const stamp = (pincode || '') + '|' + ((edd && (edd.cardText || edd.message || (edd.unserviceable ? 'na' : ''))) || '');
    kpePainting = true;

    for (let i = 0; i < count; i++) {
      const el = nodes[i];
      if (el.getAttribute('data-edd-stamp') === stamp) continue;
      const textEl = el.querySelector('[data-kpc-edd-text]') || el;
      const prefixEl = el.querySelector('[data-kpc-edd-prefix]');
      if (!pincode || !(edd && (edd.cardText || edd.unserviceable || edd.message))) {
        el.hidden = true;
        if (textEl.textContent) textEl.textContent = '';
        el.classList.remove('is-error');
        el.setAttribute('data-edd-stamp', stamp);
        continue;
      }
      if (edd.unserviceable) {
        if (isFailedCheck(edd)) {
          el.hidden = true;
          el.setAttribute('data-edd-stamp', stamp);
          continue;
        }
        if (prefixEl) prefixEl.hidden = true;
        const next = 'Not available at ' + pincode;
        if (textEl.textContent !== next) textEl.textContent = next;
        el.classList.add('is-error');
        el.hidden = false;
        el.setAttribute('data-edd-stamp', stamp);
        continue;
      }
      if (prefixEl) prefixEl.hidden = false;
      if (textEl.textContent !== edd.cardText) textEl.textContent = edd.cardText;
      el.classList.remove('is-error');
      el.hidden = false;
      el.setAttribute('data-edd-stamp', stamp);
    }
    kpeCardKey = stamp + '|' + count;
    kpePainting = false;
  }

  function updatePdpUi(pincode, edd) {
    const roots = document.querySelectorAll('[data-pdp-pincode]');
    if (!roots.length) return;
    const stamp =
      (pincode || '') +
      '|' +
      ((edd && (edd.pdpHtml || edd.message || edd.cardText || (edd.unserviceable ? 'na' : ''))) || '');
    kpePainting = true;

    for (let i = 0; i < roots.length; i++) {
      const root = roots[i];
      const input = root.querySelector('[data-pdp-input]');
      const estimate = root.querySelector('[data-pdp-estimate]');
      if (input && document.activeElement !== input && !input.value && pincode) input.value = pincode;
      if (!estimate) continue;
      if (estimate.getAttribute('data-edd-stamp') === stamp) continue;
      estimate.setAttribute('data-edd-stamp', stamp);
      if (!pincode) {
        if (estimate.innerHTML) estimate.innerHTML = '';
        estimate.classList.remove('is-error');
      } else if (edd && edd.unserviceable) {
        const next = edd.message || 'Delivery Not Available for this Pincode';
        if (estimate.textContent !== next) estimate.textContent = next;
        estimate.classList.add('is-error');
      } else if (edd && edd.pdpHtml) {
        estimate.classList.remove('is-error');
        estimate.innerHTML = edd.pdpHtml;
      } else if (edd && edd.cardText) {
        const next = edd.headerText || edd.cardText;
        estimate.classList.remove('is-error');
        if (estimate.textContent !== next) estimate.textContent = next;
      }
    }
    kpePainting = false;
  }

  function renderAll(pincode, edd) {
    paintHeaderPin(pincode);
    updateProductCards(edd, pincode);
    updatePdpUi(pincode, edd);
  }

  function clearEddStamps() {
    kpeCardKey = '';
    const nodes = document.querySelectorAll('[data-kpc-edd], [data-pdp-estimate]');
    for (let i = 0; i < nodes.length; i++) nodes[i].removeAttribute('data-edd-stamp');
  }

  function persist(pincode, city, edd) {
    if (edd) {
      edd.pincode = pincode;
      if (!edd.fetchedAt) edd.fetchedAt = Date.now();
    }
    const cityValue = city || '';
    const pinChanged = kpeMem.savedPin !== pincode;
    if (isFailedCheck(edd) && usableEdd(kpeMem.savedEdd, pincode)) {
      paintHeaderPin(pincode);
      renderAll(pincode, kpeMem.savedEdd);
      return;
    }
    const unchanged = !pinChanged && kpeMem.savedCity === cityValue && sameEdd(kpeMem.savedEdd, edd);
    kpeMem.savedPin = pincode;
    kpeMem.savedCity = cityValue;
    if (edd) kpeMem.savedEdd = edd;
    else if (pinChanged) kpeMem.savedEdd = null;
    try {
      if (kpeMem.pinSource) localStorage.setItem(KPE_SOURCE_KEY, kpeMem.pinSource);
      localStorage.setItem(KPE_PIN_KEY, pincode);
      localStorage.setItem('selectedPincode', pincode);
      localStorage.setItem(KPE_CITY_KEY, cityValue);
      writePinCookie(pincode);
      if (edd && !unchanged) localStorage.setItem(KPE_EDD_KEY, JSON.stringify(edd));
    } catch (e) {
      /* ignore */
    }

    if (unchanged) {
      renderAll(pincode, edd || (usableEdd(kpeMem.savedEdd, pincode) ? kpeMem.savedEdd : null));
      return;
    }

    if (pinChanged) clearEddStamps();

    if (!edd && pinChanged) {
      paintHeaderPin(pincode);
      return;
    }

    renderAll(pincode, edd || (usableEdd(kpeMem.savedEdd, pincode) ? kpeMem.savedEdd : null));
  }

  function refreshCards() {
    clearEddStamps();
    updateProductCards(usableEdd(kpeMem.savedEdd, kpeMem.savedPin) ? kpeMem.savedEdd : null, kpeMem.savedPin);
    updatePdpUi(kpeMem.savedPin, usableEdd(kpeMem.savedEdd, kpeMem.savedPin) ? kpeMem.savedEdd : null);
  }

  function applyPincode(pincode, options) {
    const opts = options || {};
    if (!isValidPin(pincode)) return Promise.resolve({ ok: false });

    const seq = ++kpeApplySeq;
    const cityHint = opts.city || (kpeMem.savedPin === pincode ? kpeMem.savedCity : '');
    const cached = usableEdd(kpeMem.savedEdd, pincode) ? kpeMem.savedEdd : null;
    if (opts.source === 'header' || opts.source === 'pdp') kpeMem.pinSource = 'manual';
    if (opts.source === 'geo') kpeMem.pinSource = 'geo';

    persist(pincode, cityHint, cached);
    if (cached && isFreshEdd(cached, pincode) && !opts.force) {
      return Promise.resolve({ ok: true, pincode: pincode, city: cityHint, edd: cached });
    }

    return lookupEdd(pincode).then((edd) => {
      if (seq !== kpeApplySeq || !edd) return { ok: false, pincode: pincode, edd: edd };
      persist(pincode, cityHint, edd);
      return { ok: true, pincode: pincode, city: cityHint, edd: edd };
    });
  }

  function setModalOpen(open) {
    const modal = getModal();
    const triggers = document.querySelectorAll('[data-pincode-trigger]');
    for (let i = 0; i < triggers.length; i++) {
      triggers[i].setAttribute('aria-expanded', String(open));
    }
    if (!modal) return;
    modal.hidden = !open;
    document.body.classList.toggle('pincode-modal-open', open);
    if (!open) return;
    const input = modal.querySelector('[data-pincode-input]');
    const status = modal.querySelector('[data-pincode-status]');
    if (status) {
      status.textContent = '';
      status.classList.remove('is-error', 'is-success');
    }
    if (input) {
      input.value = kpeMem.savedPin;
      setTimeout(() => {
        input.focus();
        input.select();
      }, 40);
    }
  }

  function closeAllPanels() {
    setModalOpen(false);
  }

  function showGeoError(message) {
    const status = getModal() && getModal().querySelector('[data-pincode-status]');
    if (!status) return;
    status.textContent = message;
    status.classList.add('is-error');
    status.classList.remove('is-success');
  }

  function bindModal() {
    const modal = getModal();
    if (!modal || kpeModalBound) return;
    kpeModalBound = true;
    const form = modal.querySelector('[data-pincode-form]');
    const input = modal.querySelector('[data-pincode-input]');
    const geoBtn = modal.querySelector('[data-pincode-geo]');
    const closers = modal.querySelectorAll('[data-pincode-modal-close]');

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const value = input ? input.value.trim() : '';
        const status = modal.querySelector('[data-pincode-status]');
        if (!isValidPin(value)) {
          if (status) {
            status.textContent = 'Please enter a valid 6-digit pincode';
            status.classList.add('is-error');
            status.classList.remove('is-success');
          }
          return;
        }
        applyPincode(value, { force: true, source: 'header' }).then(() => {
          refreshCards();
        });
        closeAllPanels();
      });
    }

    if (input) {
      input.addEventListener('input', () => {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
      });
    }

    if (geoBtn) {
      geoBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const status = modal.querySelector('[data-pincode-status]');
        if (status) {
          status.textContent = 'Detecting location…';
          status.classList.remove('is-error', 'is-success');
        }
        requestBrowserLocation(true);
      });
    }

    for (let c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', closeAllPanels);
    }
  }

  function bindHeader() {
    bindModal();
    if (kpeHeaderBound) return;
    kpeHeaderBound = true;
    document.addEventListener(
      'click',
      (e) => {
        const trigger = e.target.closest('[data-pincode-trigger]');
        if (!trigger || trigger.closest('[data-pincode-modal]')) return;
        e.preventDefault();
        e.stopPropagation();
        if (!isValidPin(kpeMem.savedPin || storedPincode())) {
          kpeGeoBusy = false;
          requestBrowserLocation(false);
        }
        const modal = getModal();
        setModalOpen(!modal || modal.hidden);
      },
      true
    );
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const modal = getModal();
      if (modal && !modal.hidden) closeAllPanels();
    });
  }

  function pdpEstimateFrom(target) {
    const root = target && target.closest('[data-pdp-pincode]');
    return (root && root.querySelector('[data-pdp-estimate]')) || document.querySelector('[data-pdp-pincode] [data-pdp-estimate]');
  }

  function showPdpStatus(estimate, message, isError) {
    if (!estimate) return;
    estimate.classList.toggle('is-error', Boolean(isError));
    estimate.textContent = message || '';
  }

  function applyFromPdp(value, target) {
    const estimate = pdpEstimateFrom(target);
    const pin = String(value || '').replace(/\D/g, '').slice(0, 6);
    if (!isValidPin(pin)) {
      showPdpStatus(estimate, 'Please enter a valid 6 digit pincode', true);
      return;
    }
    showPdpStatus(estimate, 'Checking delivery...', false);
    applyPincode(pin, { force: true, source: 'pdp' }).then((res) => {
      updatePdpUi(pin, res && res.edd);
      updateProductCards(res && res.edd, pin);
      paintHeaderPin(pin);
      if (!(res && res.edd)) showPdpStatus(estimate, 'Unable to check delivery. Please try again.', true);
    });
  }

  function bindPdp() {
    if (kpePdpBound) return;
    kpePdpBound = true;

    document.addEventListener('click', (e) => {
      const themeBtn = e.target.closest('[data-pdp-check]');
      if (!themeBtn) return;
      const root = themeBtn.closest('[data-pdp-pincode]');
      const input = root && root.querySelector('[data-pdp-input]');
      applyFromPdp(input ? input.value : '', themeBtn);
    });

    document.addEventListener('input', (e) => {
      const input = e.target.closest('[data-pdp-input]');
      if (!input) return;
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      const estimate = pdpEstimateFrom(input);
      if (estimate && estimate.classList.contains('is-error')) {
        estimate.textContent = '';
        estimate.classList.remove('is-error');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const input = e.target.closest('[data-pdp-input]');
      if (!input) return;
      e.preventDefault();
      applyFromPdp(input.value.trim(), input);
    });
  }

  function pinFromArcgis(data) {
    const addr = data && data.address;
    const city = (addr && (addr.City || addr.MetroArea || addr.District)) || '';
    const pin = String((addr && addr.Postal) || '').replace(/\D/g, '');
    if (isValidPin(pin)) return { pincode: pin.slice(0, 6), city: city };
    const match = String((addr && (addr.Match_addr || addr.LongLabel)) || '').match(/\b([1-9][0-9]{5})\b/);
    return match ? { pincode: match[1], city: city } : { pincode: '', city: city };
  }

  function pinFromPhoton(data) {
    const props = data && data.features && data.features[0] && data.features[0].properties;
    const city = (props && (props.city || props.name || props.locality)) || '';
    const pin = String((props && props.postcode) || '').replace(/\D/g, '');
    return { pincode: isValidPin(pin) ? pin.slice(0, 6) : '', city: city };
  }

  function pinFromBigData(data) {
    const city = (data && (data.city || data.locality || data.principalSubdivision)) || '';
    const pin = String((data && data.postcode) || '').replace(/\D/g, '');
    if (isValidPin(pin)) return { pincode: pin.slice(0, 6), city: city };
    return { pincode: '', city: city };
  }

  function pinFromNominatim(data) {
    const addr = data && data.address;
    const city = (addr && (addr.city || addr.town || addr.village || addr.state_district)) || '';
    const pin = String((addr && addr.postcode) || '').replace(/\D/g, '').slice(0, 6);
    return { pincode: isValidPin(pin) ? pin : '', city: city };
  }

  function firstResolved(promises) {
    if (typeof Promise.any === 'function') return Promise.any(promises);
    return new Promise((resolve, reject) => {
      let left = promises.length;
      const errors = [];
      promises.forEach((req, index) => {
        Promise.resolve(req).then(resolve, (err) => {
          errors[index] = err;
          left -= 1;
          if (!left) reject(errors[0] || err);
        });
      });
    });
  }

  function reverseGeocode(lat, lng) {
    const latQ = encodeURIComponent(lat);
    const lngQ = encodeURIComponent(lng);
    const pick = (value) => {
      if (value && isValidPin(value.pincode)) return value;
      throw new Error('no pin');
    };
    return firstResolved([
      fetchJson(
        'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=json&location=' +
          lngQ +
          ',' +
          latQ,
        KPE_GEO_MS
      ).then((data) => pick(pinFromArcgis(data))),
      fetchJson(
        'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + latQ + '&longitude=' + lngQ + '&localityLanguage=en',
        KPE_GEO_MS
      ).then((data) => pick(pinFromBigData(data))),
      fetchJson('https://photon.komoot.io/reverse?lon=' + lngQ + '&lat=' + latQ, KPE_GEO_MS).then((data) =>
        pick(pinFromPhoton(data))
      ),
    ]);
  }

  function getBrowserPosition() {
    return new Promise((resolve, reject) => {
      if (window.__kiehlsGeoPos && window.__kiehlsGeoPos.coords) {
        resolve(window.__kiehlsGeoPos);
        return;
      }
      if (!navigator.geolocation) {
        reject({ code: 2, message: 'unsupported' });
        return;
      }
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          window.__kiehlsGeoPos = pos;
          resolve(pos);
        },
        reject,
        { enableHighAccuracy: false, maximumAge: 300000, timeout: 10000 }
      );
    });
  }

  function commitDetectedPin(result, manual) {
    if (!result || !isValidPin(result.pincode)) return false;
    applyPincode(result.pincode, { city: result.city, source: 'geo' });
    paintHeaderPin(result.pincode);
    if (manual) closeAllPanels();
    return true;
  }

  function requestBrowserLocation(manual) {
    if (kpeGeoBusy && !manual) return;
    kpeGeoBusy = true;

    const fail = () => {
      kpeGeoBusy = false;
      if (manual) showGeoError('Unable to detect pincode. Please enter it manually.');
      else bindGestureLocationRetry();
    };

    getBrowserPosition()
      .then((position) => reverseGeocode(position.coords.latitude, position.coords.longitude))
      .then((result) => {
        kpeGeoBusy = false;
        if (!commitDetectedPin(result, manual)) fail();
      })
      .catch(() => fail());
  }

  function bindGestureLocationRetry() {
    if (kpeGeoGestureBound) return;
    kpeGeoGestureBound = true;
    const retry = () => {
      if (isValidPin(kpeMem.savedPin || storedPincode())) {
        document.removeEventListener('pointerdown', retry, true);
        return;
      }
      if (kpeGeoBusy) return;
      requestBrowserLocation(false);
    };
    document.addEventListener('pointerdown', retry, true);
  }

  function watchGeoPermission() {
    if (!navigator.permissions || !navigator.permissions.query) return;
    navigator.permissions.query({ name: 'geolocation' }).then((status) => {
      status.onchange = () => {
        if (status.state === 'granted' && !isValidPin(kpeMem.savedPin || storedPincode())) {
          kpeGeoBusy = false;
          requestBrowserLocation(false);
        }
      };
    }).catch(() => {});
  }

  function askBrowserLocationThenFetch() {
    document.addEventListener('kiehls:pincode', (event) => {
      const pin = (event.detail && (event.detail.pincode || event.detail.pin)) || '';
      if (!isValidPin(pin)) return;
      paintHeaderPin(pin);
      applyPincode(pin, { source: 'geo' });
    });
    document.addEventListener('kiehls:geo-pos', () => {
      paintHeaderPin(kpeMem.savedPin || storedPincode() || window.__kiehlsSavedPin);
      if (isValidPin(kpeMem.savedPin || storedPincode() || window.__kiehlsSavedPin)) return;
      setTimeout(() => {
        if (isValidPin(kpeMem.savedPin || storedPincode() || window.__kiehlsSavedPin)) {
          paintHeaderPin(kpeMem.savedPin || storedPincode() || window.__kiehlsSavedPin);
          return;
        }
        if (!window.__kiehlsGeoPos) return;
        kpeGeoBusy = false;
        requestBrowserLocation(false);
      }, 2500);
    });
    const saved = kpeMem.savedPin || storedPincode() || window.__kiehlsSavedPin;
    if (isValidPin(saved)) {
      applyPincode(saved, { city: kpeMem.savedCity, source: 'hydrate' });
      paintHeaderPin(saved);
      return;
    }
    watchGeoPermission();
    bindGestureLocationRetry();
    if (!navigator.geolocation) return;
    if (!window.__kiehlsGeoInFlight) requestBrowserLocation(false);
  }

  function restoreHeaderPin() {
    const pin = kpeMem.savedPin || storedPincode() || window.__kiehlsSavedPin;
    if (!isValidPin(pin)) return;
    paintHeaderPin(pin);
  }

  function fillVisibleEdd() {
    const pin = kpeMem.savedPin || storedPincode() || window.__kiehlsSavedPin;
    if (!isValidPin(pin)) return;
    const edd = usableEdd(kpeMem.savedEdd, pin) ? kpeMem.savedEdd : null;
    updateProductCards(edd, pin);
    updatePdpUi(pin, edd);
  }

  function keepHeaderPinVisible() {
    if (window.__kiehlsHeaderKeep) return;
    window.__kiehlsHeaderKeep = true;
    let headerRaf = 0;
    let eddRaf = 0;
    const scheduleHeader = () => {
      if (kpePainting || headerRaf) return;
      headerRaf = requestAnimationFrame(() => {
        headerRaf = 0;
        restoreHeaderPin();
      });
    };
    const scheduleEdd = () => {
      if (kpePainting || eddRaf) return;
      eddRaf = requestAnimationFrame(() => {
        eddRaf = 0;
        fillVisibleEdd();
      });
    };

    const header = document.getElementById('header-group');
    if (window.MutationObserver && header) {
      new MutationObserver((mutations) => {
        if (kpePainting) return;
        for (let i = 0; i < mutations.length; i++) {
          let node = mutations[i].target;
          if (node.nodeType === 3) node = node.parentElement;
          if (node && node.closest && node.closest('[data-header-pincode]')) {
            scheduleHeader();
            return;
          }
        }
      }).observe(header, { childList: true, subtree: true, characterData: true });
    }

    const main = document.getElementById('MainContent') || document.body;
    if (window.MutationObserver && main) {
      new MutationObserver((mutations) => {
        if (kpePainting) return;
        for (let i = 0; i < mutations.length; i++) {
          const added = mutations[i].addedNodes;
          for (let n = 0; n < added.length; n++) {
            const el = added[n];
            if (!el || el.nodeType !== 1) continue;
            if (
              (el.matches && el.matches('[data-kpc-edd], [data-pdp-pincode], [data-pdp-estimate]')) ||
              (el.querySelector && el.querySelector('[data-kpc-edd], [data-pdp-pincode]'))
            ) {
              scheduleEdd();
              return;
            }
          }
        }
      }).observe(main, { childList: true, subtree: true });
    }

    window.addEventListener('pageshow', () => {
      scheduleHeader();
      scheduleEdd();
    });
    window.addEventListener('pagereveal', (event) => {
      scheduleHeader();
      scheduleEdd();
      const vt = event && event.viewTransition;
      if (vt && vt.finished) {
        vt.finished.then(() => {
          scheduleHeader();
          scheduleEdd();
        }).catch(() => {});
      }
    });
    document.addEventListener('shopify:section:load', () => {
      kpeModalBound = false;
      bindHeader();
      restoreHeaderPin();
      fillVisibleEdd();
    });
  }

  function init() {
    if (window.__kiehlsEddInit) return;
    window.__kiehlsEddInit = true;
    loadMem();
    askBrowserLocationThenFetch();
    bindHeader();
    bindPdp();
    restoreHeaderPin();
    fillVisibleEdd();
    keepHeaderPinVisible();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.KiehlsPincodeEdd = Object.assign({}, window.KiehlsPincodeEdd || {}, kpeCfg, {
    applyPincode: applyPincode,
    readPin: () => kpeMem.savedPin,
    refreshCards: refreshCards,
  });
})();
